import React from 'react';
import './About.css';
import { NavLink } from "react-router-dom";

const About = () => {
    return (
        <div id="hero">
            <div className="hero container">
                <div>
                    <h1>Hello,<span></span></h1>
                    <h1>my name is <span></span></h1>
                    <h1>Jolita. <span></span></h1>
                    <h1>I’m passionate <span></span></h1>
                    <h1>about learning <span></span></h1>
                    <NavLink exact to="/contacts" className="cta">
                        Contacts
                    </NavLink>
                </div>
            </div>            
        </div>
    )
}

export default About
